import styled from 'styled-components';

import { media, Theme } from '../../../core';

export enum SizeMap {
  xsmall = '12px',
  small = '14px',
  smallmedium = '16px',
  medium = '16px',
  large = '18px',
  xlarge = '20px',
}

export enum LineHeightMap {
  xsmall = '24px',
  small = '26px',
  smallmedium = '30px',
  medium = '30px',
  large = '30px',
  xlarge = '30px',
}

export enum MobileSizeMap {
  xsmall = '12px',
  small = '12px',
  smallmedium = '14px',
  medium = '14px',
  large = '16px',
  xlarge = '18px',
}

export interface TextProps {
  size?: 'xsmall' | 'small' | 'smallmedium' | 'medium' | 'large' | 'xlarge';
  align?: 'left' | 'center' | 'right';
  weight?: '200' | '300' | '400' | '500' | '600' | '700';
  color?: string;
  noMargin?: boolean;
  lineHeight?: string;
}

const Text = styled.p<TextProps>`
  color: ${({ color, theme }) => color || theme.fontColor};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ size }) => SizeMap[size || 'medium']};
  font-weight: ${({ weight, theme }) => weight || theme.fontWeight || '600'};
  line-height: ${({ lineHeight, size, theme }) =>
    lineHeight || theme.name === Theme.theme1 ? '1.5' : LineHeightMap[size || 'medium']};
  margin: ${({ noMargin }) => (noMargin ? 0 : '0 0 12px')};
  ${({ align }) => align && `text-align: ${align};`};

  ${media.tabletPortrait} {
    margin: ${({ noMargin }) => (noMargin ? 0 : '0 0 8px')};
    font-size: ${({ size }) => MobileSizeMap[size || 'medium']};
  }

  & > a {
    text-decoration: underline !important;
  }
`;

export default Text;
